export default {
    title: 'Innovation fields',
    new: 'New',
    all: 'View all',
    empty: {
        title: 'Looking for innovations?',
        content: 'Create the first innovation field.',
        action: 'Create innovation field'
    }
}
